import { useTranslation } from 'react-i18next'
interface StickyCtaBarProps {
  onBriefingClick?: () => void
  onInquiryClick?: () => void
  briefingLabel?: string
  inquiryLabel?: string
}

const buttonBase =
  'flex-1 items-center justify-center py-5 rounded-t-[24px] border-t border-solid backdrop-blur-[12px] font-bold tracking-[-0.6px] whitespace-nowrap text-white text-[18px] md:text-[28px] [text-shadow:0_0_16px_rgba(0,0,0,0.2)]'

export function StickyCtaBar(props: StickyCtaBarProps) {
  const { t: mt } = useTranslation('marketing')
  const {
    onBriefingClick,
    onInquiryClick,
    briefingLabel = mt('header.briefing'),
    inquiryLabel = mt('franchise.franchiseContent.earlyBird.ctaLabel'),
  } = props

  return (
    <div
      data-testid="sticky-cta-bar"
      className="fixed bottom-0 inset-x-0 z-[990]"
    >
      <div className="mx-auto max-w-[1200px] w-full flex">
        <button
          type="button"
          onClick={onBriefingClick}
          className={`flex ${buttonBase}`}
          style={{
            background:
              'linear-gradient(180deg, rgba(0,149,255,0.7) 0%, rgba(0,102,227,0.7) 100%)',
            borderTopColor: 'rgba(155,245,255,0.3)',
          }}
        >
          {briefingLabel}
        </button>
        <button
          type="button"
          onClick={onInquiryClick}
          className={`flex ${buttonBase}`}
          style={{
            background:
              'linear-gradient(180deg, rgba(22,34,79,0.9) 0%, rgba(13,20,46,0.9) 100%)',
            borderTopColor: 'rgba(0,149,255,0.3)',
          }}
        >
          {inquiryLabel}
        </button>
      </div>
    </div>
  )
}
